var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 175,
    viewBox: "0 0 391 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M1.775 1.775h56.45v56.45H1.775zM58.225 1.775h56.45v56.45h-56.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M114.675 1.775h56.45v56.45h-56.45zM171.125 1.775h56.45v56.45h-56.45zM227.575 1.775h56.45v56.45h-56.45zM284.025 1.775h56.45v56.45h-56.45z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillOpacity: 0.25,
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M340.475 1.775h56.45v56.45h-56.45z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M1.775 58.225h56.45v56.45H1.775zM58.225 58.225h56.45v56.45h-56.45z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M114.675 58.225h56.45v56.45h-56.45zM171.125 58.225h56.45v56.45h-56.45zM227.575 58.225h56.45v56.45h-56.45zM284.025 58.225h56.45v56.45h-56.45zM340.475 58.225h56.45v56.45h-56.45zM1.775 114.675h56.45v56.45H1.775z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M58.225 114.675h56.45v56.45h-56.45z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M114.675 114.675h56.45v56.45h-56.45zM171.125 114.675h56.45v56.45h-56.45z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillOpacity: 0.25,
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M227.575 114.675h56.45v56.45h-56.45z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M284.025 114.675h56.45v56.45h-56.45z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillOpacity: 0.25,
    stroke: "#B0B0B0",
    strokeWidth: 3.55,
    d: "M340.475 114.675h56.45v56.45h-56.45z"
  })));
}
export default SvgSquareBackground;